var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysHiddenView = function SvgSysHiddenView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "m1.5 12.5 13-9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.007 6.359c.401.494.723 1.048.953 1.641A6.36 6.36 0 0 1 8 12a6.485 6.485 0 0 1-2.437-.487l-.97.671A7.476 7.476 0 0 0 8 13a7.357 7.357 0 0 0 6.978-4.871.388.388 0 0 0 0-.256A7.077 7.077 0 0 0 13.82 5.8l-.813.559ZM2.994 9.642A6.144 6.144 0 0 1 2.04 8 6.365 6.365 0 0 1 8 4c.836.005 1.664.17 2.438.488l.97-.67A7.477 7.477 0 0 0 8 3a7.36 7.36 0 0 0-6.978 4.872.39.39 0 0 0 0 .257A7.1 7.1 0 0 0 2.18 10.2l.814-.558Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.067 7.514A2 2 0 0 1 8 6c.074.003.149.01.222.022l1.052-.728A2.983 2.983 0 0 0 5 8c0 .081.018.157.024.236l1.043-.722ZM9.934 8.486A2 2 0 0 1 8 10a2.037 2.037 0 0 1-.222-.022l-1.052.728A2.983 2.983 0 0 0 11 8c0-.081-.018-.157-.024-.236l-1.042.722Z"
  })));
};
export default SvgSysHiddenView;